import { PageHeader } from '@sailadv/hdata-ui';
import { useTheme } from 'styled-components';

import PaginationNextArrowSvg from '@/shared/assets/icons/ui-kit/pagination-next-arrow.svg';
import { Box } from '@/shared/ui/box';
import { Icon } from '@/shared/ui/icon';
import { Text } from '@/shared/ui/text';

import { PageBackButton } from '../page-back-button';
import * as Styled from './page-wrapper.styles';
import { PageWrapperProps } from './page-wrapper.types';

const PageWrapperComponent = ({
	children,
	wrapper = false,
	back = false,
	breadcrumbs = false,
	paragraph = '0',
	overflow = 'auto',
	title = '',
	paragraphTitle = '32px',
	headerAction,
	footerAction,
}: PageWrapperProps) => {
	const {
		text: {
			colors: { secondary },
		},
	} = useTheme();
	const content = wrapper ? (
		<Styled.InnerWrapper direction="column" padding="24px">
			{children}
		</Styled.InnerWrapper>
	) : (
		children
	);

	return (
		<Styled.Wrapper>
			<Styled.ScrollableContent paragraph={paragraph} overflow={overflow}>
				{back ? (
					<div className="mx-auto flex w-full max-w-5xl flex-1 flex-col">
						<PageHeader
							title={title}
							breadcrumbs={<PageBackButton />}
							actions={headerAction}
							divider={false}
							className="bg-transparent! px-0! pt-0!"
						/>
						{content}
					</div>
				) : (
					<>
						{breadcrumbs && (
							<Styled.PageBreadCrumbs paragraph="20px" items={Array.isArray(breadcrumbs) ? breadcrumbs : undefined} />
						)}
						{title &&
							(headerAction ? (
								<Box align="center" justify="space-between" marginBottom={paragraphTitle} gap={16}>
									<Styled.PageHeaderTitle label={title} />
									{headerAction}
								</Box>
							) : (
								<Styled.PageTitle label={title} paragraph={paragraphTitle} />
							))}
						{content}
					</>
				)}
			</Styled.ScrollableContent>
			{footerAction && (
				<Styled.FooterAction onClick={footerAction.onClick} align="center" justify="end" gap={12} cursor="pointer">
					<Text label={footerAction.label} cursor="pointer" color="secondary" />
					<Icon Svg={PaginationNextArrowSvg} fill={secondary} />
				</Styled.FooterAction>
			)}
		</Styled.Wrapper>
	);
};

export default PageWrapperComponent;
